module.exports = __webpack_public_path__ + "static/media/logo.a0fa4c95.png";